import React, { useState } from "react";

// Componente original de Mentoría - mantener para uso futuro
function MentoriaContenido() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    edad: "",
    ciudad: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const BACKEND_ENDPOINT = "http://localhost:4000/api/send-mentoria";
  const INTERNAL_EMAIL = "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const payload = { ...formData };

    try {
      const res = await fetch(BACKEND_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setSuccessMessage("Tu inscripción ha sido recibida. Te contactaremos pronto.");
        setFormData({ nombre: "", apellido: "", edad: "", ciudad: "", email: "" });
        setTimeout(() => {
          setShowForm(false);
        }, 1600);
      } else {
        const text = await res.text();
        throw new Error(text || "Error al enviar");
      }
    } catch (err) {
      if (INTERNAL_EMAIL) {
        const subject = encodeURIComponent("Nueva inscripción Mentoría");
        const body = encodeURIComponent(
          `Nombre: ${formData.nombre}\nApellido: ${formData.apellido}\nEdad: ${formData.edad}\nCiudad: ${formData.ciudad}\nEmail: ${formData.email}`
        );
        window.location.href = `mailto:${INTERNAL_EMAIL}?subject=${subject}&body=${body}`;
      } else {
        setErrorMessage(
          "No se pudo enviar la inscripción automáticamente. Configura INTERNAL_EMAIL."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex flex-col gap-8 p-6 text-white bg-gray-900 min-h-screen">
      <section className="text-center max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-4 text-white drop-shadow-lg">
          Mentoría grupal (trading en vivo)
        </h1>
        <p className="text-lg text-gray-300 leading-relaxed">
          Si ya completaste el curso gratuito el próximo paso es comenzar a operar. En esta mentoría podrás aprender a analizar el mercado.
        </p>
      </section>

      <section className="max-w-2xl mx-auto w-full bg-gray-800 rounded-2xl shadow-2xl p-8">
        <h2 className="text-3xl font-semibold text-white mb-6 text-center">
          Plan de Mentoría
        </h2>

        <div className="grid md:grid-cols-2 gap-6 items-start">
          <div className="space-y-4">
            <p className="text-gray-300">
              La mentoría consiste en un plan mensual donde repasaremos conceptos, analizaremos el mercado, tomaremos entradas en vivo.
            </p>

            <ul className="text-gray-300 list-inside space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-blue-400 font-bold mt-1">✓</span>
                <span><strong>Clase teórica:</strong> 4 horas.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-400 font-bold mt-1">✓</span>
                <span><strong>10 sesiones de trading en vivo al mes:</strong> de 9:45 a 11:45 (hora de NY).</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-400 font-bold mt-1">✓</span>
                <span><strong>Grupo:</strong> Máximo 15 personas.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-400 font-bold mt-1">✓</span>
                <span><strong>Soporte:</strong> aclaración de dudas en vivo.</span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-700 p-6 rounded-lg border border-gray-600">
            <h3 className="text-2xl font-semibold text-white mb-3">Detalles</h3>
            <p className="text-gray-300 mb-4">Duración: 1 mes</p>

            <div className="space-y-3">
              <div className="flex justify-between text-gray-200">
                <span>Sesiones Teóricas</span>
                <span>01</span>
              </div>
              <div className="flex justify-between text-gray-200">
                <span>Sesiones en vivo</span>
                <span>10</span>
              </div>
              <div className="flex justify-between text-gray-200">
                <span>Formato</span>
                <span>Online (Google Meet)</span>
              </div>
              <div className="flex justify-between text-gray-200">
                <span>Precio</span>
                <span>199 USD/mes</span>
              </div>
            </div>

            <div className="mt-6">
              <button
                onClick={() => setShowForm(true)}
                className="block text-center w-full px-4 py-3 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg font-semibold shadow-md hover:from-blue-600 hover:to-blue-700 transition-all"
              >
                Inscribirme en la Mentoría
              </button>
            </div>
          </div>
        </div>
      </section>

      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black bg-opacity-60" onClick={() => setShowForm(false)} />

          <div className="relative bg-gray-800 rounded-2xl shadow-2xl p-6 max-w-lg w-full z-10">
            <h3 className="text-2xl font-semibold text-white mb-4">Formulario de inscripción</h3>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm text-gray-300 mb-1">Nombre</label>
                <input name="nombre" value={formData.nombre} onChange={handleChange} required className="w-full px-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-white" />
              </div>

              <div>
                <label className="block text-sm text-gray-300 mb-1">Apellido</label>
                <input name="apellido" value={formData.apellido} onChange={handleChange} required className="w-full px-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-white" />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Edad</label>
                  <input type="number" name="edad" value={formData.edad} onChange={handleChange} min="16" required className="w-full px-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-white" />
                </div>

                <div>
                  <label className="block text-sm text-gray-300 mb-1">Ciudad</label>
                  <input name="ciudad" value={formData.ciudad} onChange={handleChange} required className="w-full px-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-white" />
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-300 mb-1">Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 py-2 rounded-md bg-gray-700 border border-gray-600 text-white" />
              </div>

              {errorMessage && <p className="text-sm text-red-400">{errorMessage}</p>}
              {successMessage && <p className="text-sm text-green-400">{successMessage}</p>}

              <div className="flex gap-3 mt-2">
                <button type="submit" disabled={loading} className="flex-1 px-4 py-2 bg-blue-600 rounded-md font-semibold hover:bg-blue-700 disabled:opacity-60">
                  {loading ? "Enviando..." : "Enviar inscripción"}
                </button>

                <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 bg-gray-600 rounded-md">Cerrar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <section className="max-w-3xl mx-auto text-center bg-gray-800 rounded-2xl p-8 shadow-lg">
        <h3 className="text-2xl font-semibold text-white mb-4">Resultados esperados</h3>
        <p className="text-gray-300 leading-relaxed">
          Al finalizar la mentoría, tendrás la confianza y las habilidades necesarias para operar en el mercado de futuros del Nasdaq 100.
        </p>
      </section>
    </main>
  );
}

// Componente Próximamente que se exporta por defecto
function Mentoria() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white px-6">
      <div className="text-center max-w-md">
        <div className="mb-6 text-6xl">
          <span className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-yellow-500/20 border-2 border-yellow-500">
            🔨
          </span>
        </div>

        <h1 className="text-4xl font-bold mb-4">
          ¡Próximamente!
        </h1>

        <p className="text-xl text-gray-300 mb-2">
          Estamos trabajando en esta sección
        </p>
        <p className="text-gray-400 mb-8">
          Nos encontramos en pleno desarrollo. Vuelve pronto para acceder a nuestro programa de mentoría grupal en vivo.
        </p>

        <div className="mt-8 p-6 bg-gray-800 rounded-lg">
          <p className="text-sm text-gray-300 mb-2">
            <strong>📧 Mantente informado:</strong>
          </p>
          <p className="text-xs text-gray-400">
            Suscríbete a nuestro canal de YouTube para recibir notificaciones cuando la mentoría esté disponible.
          </p>
        </div>

        <div className="mt-8">
          <a
            href="/"
            className="inline-block px-8 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-lg shadow-lg hover:scale-105 transition-all"
          >
            Volver al Inicio
          </a>
        </div>
      </div>
    </div>
  );
}

export default Mentoria;
export { MentoriaContenido };
